export default "__VITE_ASSET__B6uwcX04__"